import { render, staticRenderFns } from "./SaxxText.vue?vue&type=template&id=38b7fdda"
import script from "./SaxxText.vue?vue&type=script&lang=js"
export * from "./SaxxText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports